export default __webpack_public_path__ + "static/media/icon.calendar.ec83aee6.svg";